export const PLANS = {
  FREE: {
    name: "Free",
    tier: "FREE" as const,
    description: "QA + security basics for personal projects",
    monthlyPrice: 0,
    yearlyPrice: 0,
    monthlyPriceINR: 0,
    yearlyPriceINR: 0,
    razorpayPlanId: { monthly: "", yearly: "" },
    features: [
      "10 QA test runs / month",
      "1 security scan / month",
      "Exposed secrets detection",
      "Security headers check",
      "SSL/TLS validation",
      "4 projects",
      "1 team member",
      "Community support",
    ],
    limits: { members: 1, projects: 4, runsPerMonth: 10 },
    securityScansPerMonth: 1,
    testType: "static" as const,
  },
  PRO: {
    name: "Pro",
    tier: "PRO" as const,
    description: "AI QA + full security scanning for teams",
    monthlyPrice: 49,
    yearlyPrice: 470,
    monthlyPriceINR: 3999,
    yearlyPriceINR: 38399,
    razorpayPlanId: {
      monthly: process.env.RAZORPAY_PRO_MONTHLY_PLAN_ID ?? "",
      yearly: process.env.RAZORPAY_PRO_YEARLY_PLAN_ID ?? "",
    },
    features: [
      "500 QA test runs / month",
      "Weekly security scans",
      "Full OWASP Top 10 coverage",
      "Exposed secrets + CORS + auth checks",
      "GitHub PR integration (QA + security)",
      "Visual regression testing",
      "Slack & email alerts",
      "Combined QA + security reports",
      "API access",
      "Priority support",
    ],
    limits: { members: 10, projects: -1, runsPerMonth: 500 },
    securityScansPerMonth: -1,
    testType: "ai" as const,
  },
} as const;

export type PlanKey = keyof typeof PLANS;
